/**
 * Разбор ссылок и кода встраивания Kinescope.
 *
 * Принимаем что угодно: целиком код `<iframe …>`, ссылку на embed или просто
 * идентификатор. Проверять трансляцию будут копипастой из письма, и требовать
 * «вставьте только id» значит гарантированно получить ошибку на ровном месте.
 */

/** Идентификатор в ссылках Kinescope — 22 символа base58-подобного алфавита. */
const ID_PATTERN = /[0-9A-Za-z]{16,}/

const EMBED_HOST = 'https://kinescope.io/embed/'
const CHAT_HOST = 'https://kinescope.io/chat/'

/** Вытащить идентификатор ролика или эфира из любой вставки. */
export const extractId = (input: string): string => {
  const value = input.trim()
  if (!value) return ''

  // Код встраивания или ссылка: берём то, что идёт после /embed/ или /chat/.
  const fromUrl = value.match(/kinescope\.io\/(?:embed|chat|live)\/([0-9A-Za-z]+)/)
  if (fromUrl) return fromUrl[1]

  // Просто идентификатор, без ссылки.
  const bare = value.match(ID_PATTERN)
  return bare && bare[0] === value ? value : ''
}

export interface EmbedOptions {
  /** Не проигрывать сразу: на стенде автозапуск мешает. */
  autoplay: boolean
  muted: boolean
  /** Скрыть элементы управления — проверить, как выглядит «голый» кадр. */
  hideControls: boolean
}

/** Ссылка на плеер с выбранными параметрами. */
export const buildEmbedUrl = (id: string, options: EmbedOptions): string => {
  if (!id) return ''
  const url = new URL(EMBED_HOST + id)
  if (options.autoplay) url.searchParams.set('autoplay', '1')
  if (options.muted) url.searchParams.set('muted', '1')
  if (options.hideControls) url.searchParams.set('controls', 'false')
  return url.toString()
}

/**
 * Ссылка на чат эфира. Чат — отдельный iframe, а не часть плеера, поэтому
 * «скрыть чат» на стороне сайта означает просто не встраивать его.
 *
 * Токен нужен, только если у эфира включён `chat_jwt_required`: тогда зритель
 * входит в чат под своим именем без отдельной регистрации.
 */
export const buildChatUrl = (eventId: string, token: string): string => {
  if (!eventId) return ''
  const url = new URL(CHAT_HOST + eventId)
  if (token.trim()) url.searchParams.set('token', token.trim())
  return url.toString()
}
